import { render, staticRenderFns } from "./encoding-assessment.vue?vue&type=template&id=5d281163&scoped=true"
import script from "./encoding-assessment.ts?vue&type=script&lang=ts&external"
export * from "./encoding-assessment.ts?vue&type=script&lang=ts&external"
import style0 from "./encoding-assessment.scss?vue&type=style&index=0&id=5d281163&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d281163",
  null
  
)

export default component.exports